export const purchaseOrdersEndpoints = {
  closePurchaseOrderLines: { method: 'post', path: '/{purchaseOrderId}/close-lines' },
  getPurchaseOrderByRequestId: { method: 'get', path: '/by-request/{requestId}' },
  syncPurchaseOrderByRequest: { method: 'post', path: '/by-request/{requestId}/sync' },
  updatePurchaseOrder: { method: 'post', path: '/{purchaseOrderId}/update' },
} as const
